var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.UniversitySearch = function (superClass) {
  extend(UniversitySearch, superClass);
  function UniversitySearch() {
    return UniversitySearch.__super__.constructor.apply(this, arguments);
  }
  UniversitySearch.prototype.initialize = function (options) {
    _.defaults(options, {
      placeholder: 'University',
      ajax: {
        url: '/ac_universities',
        data: function (_this) {
          return function (term, page) {
            return {
              q: term
            };
          };
        }(this),
        results: function (_this) {
          return function (data, page) {
            return {
              results: data.results
            };
          };
        }(this)
      },
      initSelection: function (element, callback) {
        var uni;
        uni = options.university;
        if ((uni != null ? uni.id : void 0) && (uni != null ? uni.name : void 0)) {
          return callback({
            id: uni.id,
            display_name: uni.name
          });
        }
      }
    });
    return UniversitySearch.__super__.initialize.apply(this, arguments);
  };
  UniversitySearch.prototype.formatSelection = function (uni, container, escapeMarkup) {
    return escapeMarkup(uni.display_name);
  };
  UniversitySearch.prototype.formatResult = function (uni, container, query, escapeMarkup) {
    return escapeMarkup(uni.display_name);
  };
  return UniversitySearch;
}(window.Search.Base);
window.extend = extend;
window.hasProp = hasProp;